import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const LogOffIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 6.60436C3 5.66696 3.65106 4.85533 4.56614 4.65198L9.56614 3.54087C10.8152 3.26331 12 4.21375 12 5.49324V18.7655C12 19.9575 10.9639 20.8849 9.77914 20.7532L4.77914 20.1977C3.76627 20.0852 3 19.229 3 18.2099V6.60436ZM4.82646 5.82341L9.82646 4.71229C10.3261 4.60127 10.8 4.98145 10.8 5.49324V18.7655C10.8 19.2423 10.3855 19.6132 9.91165 19.5606L4.91165 19.005C4.50651 18.96 4.2 18.6176 4.2 18.2099V6.60436C4.2 6.2294 4.46043 5.90475 4.82646 5.82341Z"
				fill="#4C4C58"
			/>
			<path
				d="M13.4 12.5C13.4 12.1686 13.6686 11.9 14 11.9H18.9923L17.5672 10.4155C17.3377 10.1765 17.3454 9.79666 17.5845 9.56718C17.8235 9.33769 18.2033 9.34545 18.4328 9.58449L20.8328 12.0845C21.0557 12.3167 21.0557 12.6834 20.8328 12.9155L18.4328 15.4155C18.2033 15.6546 17.8235 15.6623 17.5845 15.4328C17.3454 15.2034 17.3377 14.8235 17.5672 14.5845L18.9923 13.1H14C13.6686 13.1 13.4 12.8314 13.4 12.5Z"
				fill="#4C4C58"
			/>
			<path
				d="M14 4.90001C13.6686 4.90001 13.4 5.16864 13.4 5.50001C13.4 5.83138 13.6686 6.10001 14 6.10001H16C16.2209 6.10001 16.4 6.2791 16.4 6.50001V7.50001C16.4 7.83138 16.6686 8.10001 17 8.10001C17.3314 8.10001 17.6 7.83138 17.6 7.50001V6.50001C17.6 5.61636 16.8837 4.90001 16 4.90001H14Z"
				fill="#4C4C58"
			/>
			<path
				d="M17 16.9C17.3314 16.9 17.6 17.1686 17.6 17.5V18.5C17.6 19.3837 16.8837 20.1 16 20.1H14C13.6686 20.1 13.4 19.8314 13.4 19.5C13.4 19.1686 13.6686 18.9 14 18.9H16C16.2209 18.9 16.4 18.7209 16.4 18.5V17.5C16.4 17.1686 16.6686 16.9 17 16.9Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

LogOffIcon.propTypes = iconPropTypes;
LogOffIcon.defaultProps = iconDefaultProps;
